
(function () {

    const PlaceDirectory = {
        places: null,
        categories: [],
        tags: [],
        locations: [],
        q: null,
        placeDirectoryEl: null,
        selectedCat: null,
        noneEl: null,

        populate: (places) => {
            const template = PlaceDirectory.placeDirectoryEl.querySelector(".template > div")
            const container = template.closest(".area-container")
            PlaceDirectory.places = places
            container.querySelectorAll(".place").forEach(placeEl => {
                placeEl.remove()
            })

            PlaceDirectory.places.forEach(place => {
                const placeEl = template.cloneNode(true)
                placeEl.classList.add("place")
                let imgUrl = place.imgUrl
                // if (!imgUrl) {
                //     imgUrl = "/img/tourism/placeholder.svg"
                // }
                placeEl.style.backgroundImage = "linear-gradient(to bottom,  transparent 0%, transparent 60%,rgba(48, 48, 48, 0) 60%, rgb(0, 0, 0) 100%),url('" + imgUrl + "')"


                const nameContainerEl = document.createElement("div")
                if (place.url) {
                    const nameEl = document.createElement("a")
                    nameEl.setAttribute("href", place.url)
                    nameEl.setAttribute("target", "_blank")
                    let linkimage = " <svg width=\"28\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.993 7.049a1 1 0 0 0-.994-1L9.006 6H9a1 1 0 0 0-.006 2l5.558.036-8.259 8.258a.999.999 0 1 0 1.414 1.414l8.288-8.288L16 15A1 1 0 0 0 17 16h.001a1 1 0 0 0 1-1.001l-.008-7.95z\" fill=\"#ffffff\" fill-rule=\"evenodd\" /></svg>"
                    if (place.url.startsWith("/")) {
                        linkimage = "<svg width=\"28\" height=\"28\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5 13h11.865l-3.633 4.36a1 1 0 1 0 1.537 1.28l5-6c.039-.047.058-.102.087-.154.024-.042.053-.078.071-.124a.985.985 0 0 0 .072-.358L20 12l-.001-.004a.985.985 0 0 0-.072-.358c-.018-.046-.047-.082-.071-.124-.029-.052-.048-.107-.087-.154l-5-6a1.002 1.002 0 0 0-1.409-.128 1 1 0 0 0-.128 1.408L16.865 11H5a1 1 0 0 0 0 2\" fill=\"#ffffff\" fill-rule=\"evenodd\" /></svg>"
                    }
                    nameEl.innerHTML = place.name + linkimage

                    nameContainerEl.appendChild(nameEl)

                    const article = placeEl.querySelector(".article")
                    article.setAttribute("data-url", place.url)
                    article.addEventListener("click", (e) => {
                        if (!e.target.parentNode.classList.contains("fav-item")) { // don't link if making a favourite
                            window.open(place.url, "_blank")
                        }
                    })
                } else {
                    nameContainerEl.innerHTML = place.name;
                }

                const favEl = document.createElement("div")
                favEl.setAttribute("class", "fav-item darkbg")
                favEl.setAttribute("data-id", place.id)
                favEl.setAttribute("data-pop", true)

                const imgEl = document.createElement("img")
                imgEl.title = "favourite"
                imgEl.alt = ""
                imgEl.src = "/img/tourism/heart-16";
                if (!window.memberFavourites.includes(place.id)) {
                    imgEl.src += "-outlinewhite"
                }
                imgEl.src += ".svg"
                favEl.appendChild(imgEl)

                placeEl.querySelector(".loc").innerText = place.loc
                placeEl.querySelector(".name").appendChild(nameContainerEl)
                placeEl.querySelector(".name").appendChild(favEl)
                placeEl.querySelector(".cat").innerText = place.cat
                placeEl.querySelector(".tags").innerText = place.tags
                container.appendChild(placeEl)
            })
            PlaceDirectory.placeDirectoryEl.querySelector(".numitems").innerHTML = places.length
            PlaceDirectory.noneEl.classList.remove("active")
            if (places.length == 0) {
                PlaceDirectory.noneEl.classList.add("active")
            }
        },

        setupSearch: () => {
            const searchEl = PlaceDirectory.placeDirectoryEl.querySelector(".search")
            if (searchEl) {
                const searchButton = searchEl.querySelector("button")
                const searchInput = searchEl.querySelector("input")
                searchButton.addEventListener("click", () => {
                    PlaceDirectory.q = searchInput.value
                    PlaceDirectory.getPlaces((places) => {
                        PlaceDirectory.populate(places)
                        PlaceDirectory.setupTagFilter()
                        PlaceDirectory.setupLocationFilter()
                        PlaceDirectory.setupCategoryFilter()
                    })
                })
            }
        },

        setUpClear: () => {
            const clearEl = PlaceDirectory.placeDirectoryEl.querySelector(".clear")
            clearEl.addEventListener("click", () => {
                PlaceDirectory.clearFilters()
            })
        },

        clearFilters: () => {
            PlaceDirectory.categories = []
            PlaceDirectory.tags = []
            PlaceDirectory.locations = []
            PlaceDirectory.q = ""
            const searchEl = PlaceDirectory.placeDirectoryEl.querySelector(".search")
            if (searchEl) {
                const searchInput = searchEl.querySelector("input")
                searchInput.val = ""
            }
            PlaceDirectory.getPlaces((places) => {
                PlaceDirectory.populate(places)
                PlaceDirectory.setupTagFilter()
                PlaceDirectory.setupLocationFilter()
                PlaceDirectory.setupCategoryFilter()
            })

        },

        //setupFilters: () => {
        //    PlaceDirectory.getPlaces((places) => {
        //        PlaceDirectory.populate(places)
        //        PlaceDirectory.setupTagFilter()
        //        PlaceDirectory.setupLocationFilter()
        //        PlaceDirectory.setupLocationFilter()

        //    })
        //},

        setupCategoryFilter: () => {
            const filterEl = PlaceDirectory.placeDirectoryEl.querySelector(".cat-filter")
            filterEl.innerHTML = ""
            const categories = PlaceDirectory.getCategories(PlaceDirectory.places)
            categories.forEach(cat => {
                const catEl = document.createElement("div")
                catEl.innerText = cat
                if (PlaceDirectory.categories.includes(cat)) {
                    catEl.classList.add("active")
                }
                catEl.addEventListener("click", () => {
                    const removed = PlaceDirectory.categories.includes(cat);
                    if (PlaceDirectory.categories.includes(cat)) {
                        PlaceDirectory.categories.splice(PlaceDirectory.categories.indexOf(cat), 1);
                        catEl.classList.remove("active")
                    } else {
                        PlaceDirectory.categories.push(cat)
                        catEl.classList.add("active")
                    }
                    PlaceDirectory.getPlaces((places) => {
                        PlaceDirectory.populate(places)
                        PlaceDirectory.setupTagFilter()
                        PlaceDirectory.setupLocationFilter()
                        if (removed) {
                            PlaceDirectory.setupCategoryFilter()
                        }
                    })
                })
                filterEl.appendChild(catEl)
            })
        },


        setupTagFilter: () => {
            const filterEl = PlaceDirectory.placeDirectoryEl.querySelector(".tag-filter")
            filterEl.innerHTML = ""
            const tags = PlaceDirectory.getTags(PlaceDirectory.places)
            //console.log(tags.length)
            if (tags.length == 0) {
                filterEl.parentNode.style.display = "none"
            } else {
                filterEl.parentNode.style.display = "block"
            }
            tags.forEach(tag => {
                const tagEl = document.createElement("div")
                tagEl.innerHTML = tag
                if (PlaceDirectory.tags.includes(tag)) {
                    tagEl.classList.add("active")
                }
                tagEl.addEventListener("click", () => {
                    const removed = PlaceDirectory.tags.includes(tag)
                    if (PlaceDirectory.tags.includes(tag)) {
                        PlaceDirectory.tags.splice(PlaceDirectory.tags.indexOf(tag), 1);
                        tagEl.classList.remove("active")
                    } else {
                        PlaceDirectory.tags.push(tag)
                        tagEl.classList.add("active")
                    }
                    PlaceDirectory.getPlaces((places) => {
                        PlaceDirectory.populate(places)
                        PlaceDirectory.setupCategoryFilter()
                        PlaceDirectory.setupLocationFilter()
                        if (removed) {
                            PlaceDirectory.setupTagFilter()
                        }
                    })
                })
                filterEl.appendChild(tagEl)
            })
        },


        setupLocationFilter: () => {
            const filterEl = PlaceDirectory.placeDirectoryEl.querySelector(".loc-filter")
            filterEl.innerHTML = ""
            const locations = PlaceDirectory.getLocations(PlaceDirectory.places)
            locations.forEach(location => {
                const locationEl = document.createElement("div")
                locationEl.innerHTML = location
                if (PlaceDirectory.locations.includes(location)) {
                    locationEl.classList.add("active")
                }
                locationEl.addEventListener("click", () => {
                    const removed = PlaceDirectory.locations.includes(location);
                    if (PlaceDirectory.locations.includes(location)) {
                        PlaceDirectory.locations.splice(PlaceDirectory.locations.indexOf(location), 1);
                        locationEl.classList.remove("active")
                    } else {
                        PlaceDirectory.locations.push(location)
                        locationEl.classList.add("active")
                    }
                    PlaceDirectory.getPlaces((places) => {
                        PlaceDirectory.populate(places)
                        PlaceDirectory.setupCategoryFilter()
                        PlaceDirectory.setupTagFilter()
                        if (removed) {
                            PlaceDirectory.setupLocationFilter()
                        }
                    })
                })
                filterEl.appendChild(locationEl)
            })
        },


        getCategories: (places) => {
            let result = [];
            places.forEach(place => {
                if (!result.includes(place.cat)) {
                    result.push(place.cat)
                }
            })
            result.sort()
            return result;
        },

        getTags: (places) => {
            let result = [];
            places.forEach(place => {
                if (place.tags) {
                    const tagItems = place.tags.split(",")
                    tagItems.forEach(tag => {
                        if (tag && !result.includes(tag)) {
                            result.push(tag)
                        }
                    })
                }
                result.sort()
            })
            return result;
        },

        getLocations: (places) => {
            let result = [];
            places.forEach(place => {
                if (place.loc && !result.includes(place.loc)) {
                    result.push(place.loc)
                }
                result.sort((a, b) => { return a.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") > b.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") ? 1 : -1 })
            })
            return result;
        },

        getPlaces: (callback) => {
            const requestVerificationToken = PlaceDirectory.placeDirectoryEl
                .querySelector("input[name='__RequestVerificationToken']").value
            fetch("/umbraco/surface/PlaceDirectory", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "RequestVerificationToken": requestVerificationToken,
                },
                body: JSON.stringify({
                    tags: PlaceDirectory.tags,
                    cats: PlaceDirectory.categories,
                    locations: PlaceDirectory.locations,
                    q: PlaceDirectory.q,
                    categoryToDisplay: PlaceDirectory.selectedCat
                })
            }).then(resp => {
                resp.json().then(data => {
                    if (data && data.places) {

                        if (callback) {
                            callback(data.places)
                        }
                    }
                })
            })
        },

        setUpFunnel: () => {
            const filterEl = PlaceDirectory.placeDirectoryEl.querySelector(".filter")
            const funnelEl = filterEl.querySelector(".funnel")
            const selectionsEl = filterEl.querySelector(".filter-selections")
            funnelEl.addEventListener("click", () => {
                if (selectionsEl.classList.contains("hide")) {
                    selectionsEl.classList.remove("hide")
                } else {
                    selectionsEl.classList.add("hide")
                }
            })
        },

        setupMobileFilter: () => {
            const filterEl = PlaceDirectory.placeDirectoryEl.querySelector(".filter")
            const catLabelEl = filterEl.querySelector(".catlabel")
            const tagLabelEl = filterEl.querySelector(".taglabel")
            const locLabelEl = filterEl.querySelector(".loclabel")

            const catFilterEl = filterEl.querySelector(".cat-filter")
            const tagFilterEl = filterEl.querySelector(".tag-filter")
            const locFilterEl = filterEl.querySelector(".loc-filter")

            catLabelEl.addEventListener("click", () => {
                catFilterEl.classList.remove("active")
                tagFilterEl.classList.remove("active")
                locFilterEl.classList.remove("active")
                catFilterEl.classList.add("active")

                catLabelEl.classList.remove("active")
                tagLabelEl.classList.remove("active")
                locLabelEl.classList.remove("active")
                catLabelEl.classList.add("active")
            })
            tagLabelEl.addEventListener("click", () => {
                catFilterEl.classList.remove("active")
                tagFilterEl.classList.remove("active")
                locFilterEl.classList.remove("active")
                tagFilterEl.classList.add("active")

                catLabelEl.classList.remove("active")
                tagLabelEl.classList.remove("active")
                locLabelEl.classList.remove("active")
                tagLabelEl.classList.add("active")
            })
            locLabelEl.addEventListener("click", () => {
                catFilterEl.classList.remove("active")
                tagFilterEl.classList.remove("active")
                locFilterEl.classList.remove("active")
                locFilterEl.classList.add("active")

                catLabelEl.classList.remove("active")
                tagLabelEl.classList.remove("active")
                locLabelEl.classList.remove("active")
                locLabelEl.classList.add("active")
            })

        },


        init: () => {
            PlaceDirectory.placeDirectoryEl = document.getElementById("placedirectory")
            if (PlaceDirectory.placeDirectoryEl) {
                PlaceDirectory.noneEl = PlaceDirectory.placeDirectoryEl.querySelector(".none")
                PlaceDirectory.setupMobileFilter()
                PlaceDirectory.setUpFunnel()
                PlaceDirectory.selectedCat = PlaceDirectory.placeDirectoryEl.dataset.catid
                if (PlaceDirectory.placeDirectoryEl) {
                    const formEl = PlaceDirectory.placeDirectoryEl.querySelector("form")
                    formEl.addEventListener("submit", (e) => {
                        e.preventDefault()
                    })
                    PlaceDirectory.getPlaces((places) => {
                        PlaceDirectory.populate(places)
                        PlaceDirectory.setupCategoryFilter()
                        PlaceDirectory.setupTagFilter()
                        PlaceDirectory.setupLocationFilter()
                        PlaceDirectory.setupSearch()
                        PlaceDirectory.setUpClear()
                    })
                }
            }
        }
    };
    PlaceDirectory.init();

    document.onscroll = () => {
        //console.log(window.scrollY);
        if (PlaceDirectory.placeDirectoryEl) {
            const pRect = PlaceDirectory.placeDirectoryEl.getBoundingClientRect()
            const funnel = PlaceDirectory.placeDirectoryEl.querySelector(".funnel")
            const vWidth = window.innerWidth || document.documentElement.clientWidth;
            if (pRect.top < 70 && pRect.bottom > 245 && vWidth > 1200) {
                funnel.style.top = "60px"
            } else {
                funnel.style.top = null
            }
            //console.log(pRect.bottom, pRect.height)
        }
    }

})();